import { paymentGatewayApi } from "@api/instances";

const createZuoraPaymentSession = async (): Promise<string> => {
  const response = await paymentGatewayApi.post<string>(
    "/v1/billing/payment-session",
    {},
    { requireAuth: true },
  );
  return response.data;
};

export default createZuoraPaymentSession;
